import CustomImage from "@components/custom-image";
import { recipeImageCandidates } from "@provider/image-url";
import AnimatedLink from "@components/animated-link";
import { roundness } from "@provider/dripsy";
import type { Recipe } from "@type/recipe";
import { Text, useSx, View } from "dripsy";
import * as React from "react";
import { Platform } from "react-native";

import RecipeFavouriteButton from "./favourite/recipe-favourite-button";
import RecipeDetailView from "./recipe-detail-view";
import routes from "../../NavigatorRoutes";

function RecipeItem({ recipe, maxWidth }: { recipe: Recipe; maxWidth?: number }) {
  const sx = useSx();
  return (
    <View>
      <AnimatedLink
        to={routes.RecipeDetailScreen}
        params={{ id: `${recipe.id}` }}
        style={sx({
          height: 200,
          maxWidth,
          shadowColor: "$text",
          shadowRadius: 3.84,
          py: "$2",
          px: "$2",
          shadowOffset: {
            width: 0,
            height: 2,
          } as any,
          borderRadius: roundness,
          overflow: "hidden",
          justifyContent: "space-between",
        })}
      >
        <View
          sx={{ position: "absolute", top: 0, right: 0, left: 0, bottom: 0, backgroundColor: "$text", opacity: 0.5 }}
        />
        <CustomImage
          source={recipeImageCandidates(recipe, 1600)}
          sx={{
            alignSelf: "center",
            position: "absolute",
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            zIndex: -10,
          }}
          alt={recipe.title}
        />

        <View
          sx={{
            width: "100%",
            borderRadius: roundness,
            justifyContent: "flex-end",
            height: 200 - 24,
            // maxWidth: 160,
          }}
        >
          <RecipeDetailView recipe={recipe} isSmall />
          <Text
            sx={{
              fontSize: 15,
              fontWeight: Platform.select({ web: "600", default: "800" }),
              color: "$background",
              mt: "$1",
            }}
          >
            {recipe.title}
          </Text>
        </View>
      </AnimatedLink>
      <View sx={{ position: "absolute", top: 12, left: 12 }}>
        <RecipeFavouriteButton recipe={recipe} />
      </View>
    </View>
  );
}
export default RecipeItem;
